export default __webpack_public_path__ + "static/media/info-icon.0df72a05.svg";